var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19304 2.76688C8.1006 2.25539 8.55366 2 9.05 2C9.54634 2 9.9994 2.25539 10.907 2.76688L12.1695 3.47821C13.1109 4.00846 13.582 4.27394 13.841 4.71762C14.1 5.1613 14.1 5.70237 14.1 6.78451V8.03691C14.1 9.11906 14.1 9.66013 13.8403 10.1038C13.582 10.5475 13.1116 10.813 12.1695 11.3432L10.907 12.0546C9.9994 12.566 9.54634 12.8214 9.05 12.8214C8.55366 12.8214 8.1006 12.566 7.19304 12.0546L5.93054 11.3432C4.98908 10.813 4.51799 10.5475 4.25899 10.1038C4 9.66013 4 9.11906 4 8.03691V6.78451C4 5.70237 4 5.1613 4.25971 4.71762C4.51799 4.27394 4.98836 4.00846 5.93054 3.47821L7.19304 2.76688Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88664 7.89182C6.88664 7.89182 7.42772 7.89182 7.96879 8.85349C7.96879 8.85349 9.68723 6.44897 11.2152 5.96777M12.5737 11.3785L13.057 13.6943C13.3672 15.1819 13.5231 15.9257 13.2035 16.2784C12.8846 16.6312 12.3305 16.3282 11.2224 15.7215L9.5819 14.8233C9.32002 14.6805 9.18944 14.6083 9.05093 14.6083C8.91242 14.6083 8.78184 14.6805 8.51996 14.8233L6.87943 15.7215C5.77131 16.3275 5.21726 16.6312 4.89839 16.2784C4.57951 15.9257 4.73462 15.1819 5.04484 13.6943L5.52819 11.3785",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.57f1e8e781444213338017c9b6cb289f.svg";
export { ForwardRef as ReactComponent };